import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {API} from './api/api';
import {NavigationService} from '@ngx-seatback/utils';
import {UtilService} from './util.service';

@Injectable()
export class RouteGuardAdminService implements CanActivate, CanActivateChild {

  constructor(private api: API, private router: Router, private navService: NavigationService, public util: UtilService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAdmin();
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkAdmin();
  }

  checkAdmin() {
    return this.api._admin_AdminEndpoints_uptime()
      .pipe(map(data => {
        return true;
      })).pipe(catchError((error => {
        this.navService.navigateToPoint(this.util.RoutingID.admin);
        return of(false);
      })));
  }
}
